const LEGACY_TOKEN_STORAGE_KEY = 'jwtToken'

export function getToken() {
  if (typeof localStorage === 'undefined') {
    return null
  }
  return localStorage.getItem(LEGACY_TOKEN_STORAGE_KEY)
}

export function setToken(token) {
  if (!token || typeof localStorage === 'undefined') {
    return
  }
  localStorage.setItem(LEGACY_TOKEN_STORAGE_KEY, token)
}

export function clearToken() {
  if (typeof localStorage === 'undefined') {
    return
  }
  localStorage.removeItem(LEGACY_TOKEN_STORAGE_KEY)
}

export function isTokenExpired(token) {
  if (!token) {
    return true
  }
  const parts = token.split('.')
  if (parts.length < 2) {
    return true
  }
  try {
    const payloadBase64 = parts[1]
      .replace(/-/g, '+')
      .replace(/_/g, '/')
    const payload = JSON.parse(window.atob(payloadBase64))
    if (!payload || typeof payload.exp !== 'number') {
      return true
    }
    return Date.now() > payload.exp * 1000 - 10 * 1000
  } catch (error) {
    return true
  }
}



// WEBPACK FOOTER //
// ./src/helpers/auth-storage.js